<template>
    <div>
        <div v-if="!item.children">
            <Link
                :class="[item.current ? 'bg-gray-200 text-gray-900' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900', 'group w-full flex items-center pl-2 py-2 text-sm font-medium rounded-md']"
                :href="item.href">
                <component
                    :is="item.icon"
                    :class="[item.current ? 'text-gray-700' : 'text-gray-400 group-hover:text-gray-500', 'mr-2 flex-shrink-0 h-5 w-5']"
                    aria-hidden="true"/>
                {{ item.name }}
            </Link>
        </div>
        <Disclosure v-else v-slot="{ open }" :default-open="item.current" as="div" class="space-y-1">
            <DisclosureButton
                :class="[item.current ? 'bg-gray-100 ' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900', 'group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500']">
                <component
                    :is="item.icon" aria-hidden="true"
                    class="mr-2 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"/>
                <span class="flex-1">{{ item.name }}</span>
                <svg
                    :class="[open ? 'text-gray-400 rotate-90' : 'text-gray-300', 'ml-3 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out group-hover:text-gray-400']"
                    aria-hidden="true" viewBox="0 0 20 20">
                    <path d="M6 6L14 10L6 14V6Z" fill="currentColor"/>
                </svg>
            </DisclosureButton>
            <DisclosurePanel class="space-y-1">
                <Link
                    v-for="subItem in item.children" :key="subItem.name"
                    :class="[subItem.current ? 'bg-gray-200 text-gray-900' : '']"
                    :href="subItem.href"
                    class="group flex w-full items-center rounded-md py-2 pl-11 pr-2 text-sm font-medium text-gray-600 hover:bg-gray-200 hover:text-gray-900">
                    {{ subItem.name }}
                </Link>
            </DisclosurePanel>
        </Disclosure>
    </div>
</template>
<script>
import {Disclosure, DisclosureButton, DisclosurePanel} from '@headlessui/vue';
import {
    BanknotesIcon,
    Bars3Icon,
    BoltIcon,
    CalendarIcon,
    ChartBarIcon,
    ChatBubbleBottomCenterTextIcon,
    DocumentMagnifyingGlassIcon,
    FolderIcon,
    HomeIcon,
    InboxIcon,
    PresentationChartLineIcon,
    SignalIcon,
    Square3Stack3DIcon,
    UserGroupIcon,
    UsersIcon,
    XMarkIcon,
} from '@heroicons/vue/24/outline/esm/index.js';

import AnonymousUserIcon from '@/Components/Legacy/Icons/AnonymousUserIcon.vue';
import DiscountIcon from '@/Components/Legacy/Icons/DiscountIcon.vue';
import {Link} from '@inertiajs/vue3';

export default {
    components: {
        Link,
        PresentationChartLineIcon,
        SignalIcon,
        Square3Stack3DIcon,
        DiscountIcon,
        BanknotesIcon,
        ChatBubbleBottomCenterTextIcon,
        Bars3Icon,
        CalendarIcon,
        ChartBarIcon,
        FolderIcon,
        UserGroupIcon,
        HomeIcon,
        InboxIcon,
        UsersIcon,
        XMarkIcon,
        BoltIcon,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        DocumentMagnifyingGlassIcon,
        AnonymousUserIcon,
    },
    props: {
        item: {
            type: Object,
            required: true,
        }
    }
};
</script>
